import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { FullWidthSpinner } from './loader-components';

export default function Redirect() {
    useEffect(() => {
        console.log('Preparing to redirect to Telegram bot...');
        setTimeout(() => {
            console.log('Redirecting to Telegram bot...');
            window.location.replace('https://t.me/SwensensBot');
        }, 250);
    }, []);

    return (
            <FullWidthSpinner
                text='Please wait...'
                heightInVH={isMobile ? 74 : 100}
                scale={3} />
    )

    // return (
    //     <>
    //         Loading...
    //     </>
    // )
}